import { useMemo } from 'react'
import './DateInput.scss'
import { isEmpty } from '../../Utils/Validations'

interface DateInputProps {
  type: 'datetime-local' | 'date' | 'time'
  value?: number
  onChange?: (newValue: number | undefined) => void
  label?: string
  helperText?: string
  placeholder?: number
  isValid?: boolean
  isReadOnly?: boolean
  min?: number
  max?: number
}

export function DateInput({
  type,
  value,
  onChange,
  label,
  helperText,
  placeholder,
  isValid,
  isReadOnly,
  min,
  max,
}: DateInputProps) {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (event.target.value === '') {
        if (onChange) {
          onChange(undefined)
        }
      } else {
        let newValue = new Date(event.target.value).getTime()
        if (isNaN(newValue)) return

        if (min !== undefined && newValue < min) newValue = min
        if (max !== undefined && newValue > max) newValue = max
        if (onChange) {
          onChange(newValue)
        }
      }
    } catch (err) {
      console.error('Issue parsing new date', err)
    }
  }

  const formattedValue = useMemo(() => {
    if (value === undefined || value === null || isNaN(value)) return ''

    const dateValue = new Date(value)

    switch (type) {
      case 'datetime-local':
        return dateValue.toISOString()
      case 'date':
        return dateValue.toISOString().split('T')[0]
      case 'time':
        return dateValue.toISOString().split('T')[1]
    }
  }, [value, type])

  return (
    <div
      className={`date-input ${isValid === false ? 'invalid' : ''} ${
        isReadOnly ?? false ? 'is-read-only' : ''
      }`}
    >
      {!isEmpty(label) ? <div className="input-label">{label}</div> : null}{' '}
      <input
        type={type}
        className="input-element"
        value={formattedValue}
        onChange={handleInputChange}
        placeholder={`${placeholder}`}
        min={min}
        max={max}
        readOnly={isReadOnly}
      />
      {!isEmpty(helperText) ? (
        <div className="input-helper-text">{helperText}</div>
      ) : null}
    </div>
  )
}
